import { useState } from "react"
import Typography from "component-lib/Base/components/Typography"
import { makeStyles } from "tss-react/mui"
import { ReactSVG } from "react-svg"
import getContentUrl from "utils-lib/getContentUrl"
import { getWindow } from "utils-lib/getWindow"
import { Link, Button } from "../../../Base"
import "./sevenCard.scss"

const ssrWindow = getWindow()

const useStyles = makeStyles()((theme) => ({
  headingDisplay: {
    [theme.breakpoints.down(`sm`)]: {
      paddingLeft: `1.5rem`,
      paddingRight: `10px`,
    },
  },
}))

const ServiceSolutioncard = (cardList) => {
  const [isExpand, setIsExpand] = useState(false)
  const symbol = isExpand ? `minus` : `plus`
  const bodyWidth =
    ssrWindow.innerWidth > 0 ? ssrWindow.innerWidth : ssrWindow.screen.width
  const { classes } = useStyles()

  // this is the minimum change to make the component work with react 19
  // the parameters are incorrect, `cardList` contains all props (should be named `props`),
  // collapse will always be undefined with this definition
  // react 18 is not as strict as react 19, so it will incorrectly allow the test case to pass
  const collapseCondition = cardList.collapse

  return (
    <>
      <div
        className="row ServiceSolutioncard"
        data-testid="ServiceSolutionCard"
      >
        <div className="card">
          <img
            className="card-img-top img-circle rounded-circle"
            src={getContentUrl(cardList?.cardList?.cardImage)}
            alt={cardList?.cardList?.imageAltText}
          />
          <div className="card-block">
            <div
              className={`${
                cardList?.cardList?.cardImage
                  ? "WmcontentcardwithImage"
                  : "WmcontentcardwithoutImage"
              }`}
            >
              <div
                className="maax-font-weight-bold cardItemtitle"
                data-testid="ServiceSolutionCard-cardEyebrowText"
              >
                {cardList?.cardList?.cardEyebrowText}
              </div>
              <Typography
                className="cardHeading maax-font-weight-bold"
                variant={bodyWidth < 1025 ? "h4" : "h3"}
                style={{ color: "black" }}
                data-testid="ServiceSolutionCard-cardHeading"
              >
                {cardList?.cardList?.cardHeading}
              </Typography>
              <div
                className="flex-grow-1 cardItemsubText maax-font-weight-regular"
                data-testid="ServiceSolutionCard-cardBody"
              >
                {cardList?.cardList?.cardBody}
              </div>
              <Link
                overrideClass="maax-font-weight-regular"
                href={cardList?.cardList?.cardCtaURL}
                isExternalLink={cardList?.cardList?.externalLink}
                analytics_key={
                  cardList?.cardList?.analyticsKey ||
                  `${cardList?.cardList?.cardHeading} ${cardList?.cardList?.cardCtaText} ${cardList?.cardList?.cardCtaURL}`
                }
              >
                {cardList?.cardList?.cardCtaText}
              </Link>
            </div>
          </div>
        </div>
      </div>
      {collapseCondition ? (
        <div
          className="ServiceSolutioncardMobile"
          data-testid="ServiceSolutioncardMobile"
        >
          <div
            {...{
              className: `accordion-item accordion-item--${
                isExpand ? `opened` : `cloosed`
              }`,
            }}
          >
            <Button
              ariaExpanded={isExpand}
              overrideClass={` accordion-item__line text-left Body accordion-item__title maax-font-weight-bold`}
              analytics_key={`${symbol}`}
              onClick={() => {
                setIsExpand(!isExpand)
              }}
            >
              <span
                className={`${classes.headingDisplay}`}
                style={{ display: !isExpand ? "block" : "none" }}
              >
                {cardList?.cardList?.cardHeading}
              </span>
              <div className={`accordion-item__icon ${symbol}`}>
                <ReactSVG
                  wrapper="span"
                  src={
                    !isExpand
                      ? getContentUrl(`/content/dam/wm/icons/plus-green.svg`)
                      : getContentUrl(`/content/dam/wm/icons/minus-green.svg`)
                  }
                />
              </div>
            </Button>
            <div
              {...{ className: `accordion-item__inner` }}
              style={{ background: !isExpand ? "" : "white" }}
              aria-hidden={!isExpand}
              tabIndex={isExpand ? 0 : -1}
            >
              <img
                className="card-img-top img-circle rounded-circle"
                src={getContentUrl(cardList?.cardList?.cardImage)}
                alt={cardList?.cardList?.imageAltText}
              />
              <div className="card-block">
                <div
                  className={`${
                    cardList?.cardList?.cardImage
                      ? "WmcontentcardwithImage"
                      : "WmcontentcardwithoutImage"
                  }`}
                >
                  <div className="maax-font-weight-bold cardItemtitle">
                    {cardList?.cardList?.cardEyebrowText}
                  </div>
                  <Typography
                    className="cardHeading maax-font-weight-bold"
                    variant="h4"
                    style={{ color: "black" }}
                  >
                    {cardList?.cardList?.cardHeading}
                  </Typography>
                  <div className="flex-grow-1 cardItemsubText maax-font-weight-regular">
                    {cardList?.cardList?.cardBody}
                  </div>
                  <div className="servicesolutionCta">
                    <Link
                      overrideClass="maax-font-weight-regular"
                      href={cardList?.cardList?.cardCtaURL}
                      isExternalLink={cardList?.cardList?.externalLink}
                      analytics_key={
                        cardList?.cardList?.analyticsKey ||
                        `${cardList?.cardList?.cardHeading} ${cardList?.cardList?.cardCtaText} ${cardList?.cardList?.cardCtaURL}`
                      }
                    >
                      {cardList?.cardList?.cardCtaText}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  )
}
export default ServiceSolutioncard
